
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "atlas-repair-index"
    }}>{`Atlas Repair Index`}</h1>
    <h2 {...{
      "id": "introduction"
    }}>{`Introduction`}</h2>
    <p>{`The document describes the use of the Atlas Index Repair Utility for JanusGraph, with HBase as back-end data store and Solr as index store.`}</p>
    <h4 {...{
      "id": "need-for-this-tool"
    }}>{`Need for this Tool`}</h4>
    <p>{`In rare, cases it is possible that during entity creation, the entity is stored in the data store, but the corresponding indexes are not created in Solr. Since Atlas relies heavily on Solr in the operation of its Basic Search, this will result in entity not being returned by a search. Note that Advanced Search is not affected by this.`}</p>
    <h4 {...{
      "id": "location"
    }}>{`Location`}</h4>
    <p>{`The tool is part of the normal Atlas installation, it is located under the tools/atlas-index-repair directory.`}</p>
    <h4 {...{
      "id": "steps-to-execute-tool"
    }}>{`Steps to Execute Tool`}</h4>
    <h5 {...{
      "id": "complete-restore"
    }}>{`Complete Restore`}</h5>
    <p>{`If the user needs to restore all the indexes, this can be accomplished by executing the tool with no command-line parameters:`}</p>
    <SyntaxHighlighter wrapLines={true} language="powershell" style={theme.dark} mdxType="SyntaxHighlighter">
atlas-index-repair/repair_index.py
    </SyntaxHighlighter>
    <p>{`This will result in vertex_index, edge_index and fulltext_index to be re-built completely. It is recommended that existing contents of these indexes be deleted before executing this restore.`}</p>
    <h6 {...{
      "id": "caveats"
    }}>{`Caveats`}</h6>
    <p>{`Note that the full index repair is a time-consuming process. Depending on the size of data the process may take days to complete. During the restore process the Basic Search functionality will not be available. Be sure to allocate sufficient time for this activity.`}</p>
    <h5 {...{
      "id": "selective-restore"
    }}>{`Selective Restore`}</h5>
    <p>{`To perform selective restore for an Atlas entity, specify the GUID of that entity:`}</p>
    <SyntaxHighlighter wrapLines={true} language="powershell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`atlas-index-repair/repair_index.py [-g \<guid>]`}
    </SyntaxHighlighter>
    <p>{`Example:`}</p>
    <SyntaxHighlighter wrapLines={true} language="powershell" style={theme.dark} mdxType="SyntaxHighlighter">
atlas-index-repair/repair_index.py -g 13d77457-2a45-4e92-ad53-a172c7cb70a5
    </SyntaxHighlighter>
    <p>{`Note that Atlas will use REST APIs to fetch the entity, which will need correct authentication mechanism to be specified based on the installation.`}</p>
    <p>{`For an Atlas installation with username and password use:`}</p>
    <SyntaxHighlighter wrapLines={true} language="powershell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`atlas-index-repair/repair_index.py [-g \<guid>] [-u \<user>] [-p \<password>]`}
    </SyntaxHighlighter>
    <ul>
      <li parentName="ul">{`guid: `}{`[optional]`}{` specify guid for which indexes are to be updated`}</li>
      <li parentName="ul">{`user: `}{`[optional]`}{` specify username for atlas instance`}</li>
      <li parentName="ul">{`password: `}{`[optional]`}{` specify password for atlas instance`}</li>
    </ul>
    <p>{`Example:`}</p>
    <SyntaxHighlighter wrapLines={true} language="powershell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`atlas-index-repair/repair_index.py -u admin -p admin123 -g
	13d77457-2a45-4e92-ad53-a172c7cb70a5`}
    </SyntaxHighlighter>
    <p>{`For Atlas installation that uses kerberos as authentication mode,
use: `}</p>
    <ul>
      <li parentName="ul">{`Add below to DEFAULT_JVM_OPTS in repair_index.py`}
        <SyntaxHighlighter wrapLines={true} language="powershell" style={theme.dark} mdxType="SyntaxHighlighter">
          {`-Djavax.security.auth.useSubjectCredsOnly=false -Djava.security.auth.login.config=atlas_jaas.conf`}
        </SyntaxHighlighter>
  
      </li>
      <li parentName="ul">{`kinit -kt /etc/security/keytabs/atlas.service.keytab atlas/fqdn@DOMAIN`}</li>
    </ul>
    <p>{`For Atlas installation that uses SSL, we need to make sure to add Solr cert or RootCA certificate, use below atlas-application properties:`}</p>
    <ul>
      <li parentName="ul">{`keystore.file {path to keystore jks file}`}</li>
      <li parentName="ul">{`truststore.file {path to truststore jks file}`}</li>
      <li parentName="ul">{`cert.stores.credential.provider.path {path to jceks file}`}</li>
    </ul>
    <p>{`Example:`}</p>
    <SyntaxHighlighter wrapLines={true} language="powershell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`kinit -kt /etc/security/keytabs/atlas.service.keytab atlas/fqdn@EXAMPLE.com
	atlas-index-repair/repair_index.py -g 13d77457-2a45-4e92-ad53-a172c7cb70a5`}
    </SyntaxHighlighter>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;